import { formatNumberWithoutCommas } from "./formatNumberWithCommas";

export const filter = (rows, searchQuery, searchColumns = []) => {

  return rows?.filter((row) => {
    if (searchColumns.length === 0) {
      return Object.values(row).some((value) =>
        String(value).toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    return searchColumns.some((column) => {
      const valueToSearch = formatNumberWithoutCommas(row[column] ? String(row[column]).toLowerCase() : "");
      return valueToSearch.includes(searchQuery.toLowerCase());
    });
  });
};
